import { SvgIcon, SvgIconProps } from '@mui/material';

export const MarketIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.375 14.4062H16.7188V1.28125C16.7188 1.1072 16.6496 0.940282 16.5265 0.817211C16.4035 0.694141 16.2365 0.625 16.0625 0.625H11.4688C11.2947 0.625 11.1278 0.694141 11.0047 0.817211C10.8816 0.940282 10.8125 1.1072 10.8125 1.28125V4.5625H6.875C6.70095 4.5625 6.53403 4.63164 6.41096 4.75471C6.28789 4.87778 6.21875 5.0447 6.21875 5.21875V8.5H2.9375C2.76345 8.5 2.59653 8.56914 2.47346 8.69221C2.35039 8.81528 2.28125 8.9822 2.28125 9.15625V14.4062H1.625C1.45095 14.4062 1.28403 14.4754 1.16096 14.5985C1.03789 14.7215 0.96875 14.8885 0.96875 15.0625C0.96875 15.2365 1.03789 15.4035 1.16096 15.5265C1.28403 15.6496 1.45095 15.7188 1.625 15.7188H17.375C17.549 15.7188 17.716 15.6496 17.839 15.5265C17.9621 15.4035 18.0312 15.2365 18.0312 15.0625C18.0312 14.8885 17.9621 14.7215 17.839 14.5985C17.716 14.4754 17.549 14.4062 17.375 14.4062ZM12.125 1.9375H15.4062V14.4062H12.125V1.9375ZM7.53125 5.875H10.8125V14.4062H7.53125V5.875ZM3.59375 9.8125H6.21875V14.4062H3.59375V9.8125Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};

export const MarketIconFilled = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        width="19"
        height="16"
        viewBox="0 0 19 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.0312 15.0625C18.0312 15.2365 17.9621 15.4035 17.839 15.5265C17.716 15.6496 17.549 15.7188 17.375 15.7188H1.625C1.45095 15.7188 1.28403 15.6496 1.16096 15.5265C1.03789 15.4035 0.96875 15.2365 0.96875 15.0625C0.96875 14.8885 1.03789 14.7215 1.16096 14.5985C1.28403 14.4754 1.45095 14.4062 1.625 14.4062H2.28125V9.15625C2.28125 8.9822 2.35039 8.81528 2.47346 8.69221C2.59653 8.56914 2.76345 8.5 2.9375 8.5H4.90625C5.0803 8.5 5.24722 8.56914 5.37029 8.69221C5.49336 8.81528 5.5625 8.9822 5.5625 9.15625V14.4062H6.875V5.21875C6.875 5.0447 6.94414 4.87778 7.06721 4.75471C7.19028 4.63164 7.3572 4.5625 7.53125 4.5625H10.1562C10.3303 4.5625 10.4972 4.63164 10.6203 4.75471C10.7434 4.87778 10.8125 5.0447 10.8125 5.21875V14.4062H12.125V1.28125C12.125 1.1072 12.1941 0.940282 12.3172 0.817211C12.4403 0.694141 12.6072 0.625 12.7812 0.625H16.0625C16.2365 0.625 16.4035 0.694141 16.5265 0.817211C16.6496 0.940282 16.7188 1.1072 16.7188 1.28125V14.4062H17.375C17.549 14.4062 17.716 14.4754 17.839 14.5985C17.9621 14.7215 18.0312 14.8885 18.0312 15.0625Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
